import { cn } from '@/lib/utils';

/**
 * PLACEHOLDER LINK — Bramble is not on the App Store yet.
 * Swap this for the real listing URL (or a TestFlight public link) once the
 * app is submitted. Nothing else on the site needs to change.
 */
export const APP_STORE_URL = 'https://apps.apple.com/app/id0000000000';

function AppleGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path d="M16.36 12.63c-.02-2.35 1.92-3.48 2-3.53-1.09-1.6-2.79-1.82-3.39-1.84-1.44-.15-2.82.85-3.55.85-.74 0-1.86-.83-3.06-.81-1.57.02-3.03.92-3.84 2.33-1.64 2.84-.42 7.04 1.17 9.34.78 1.13 1.71 2.39 2.93 2.35 1.18-.05 1.62-.76 3.05-.76 1.42 0 1.83.76 3.07.73 1.27-.02 2.07-1.15 2.85-2.28.9-1.31 1.27-2.58 1.29-2.64-.03-.01-2.48-.95-2.5-3.77zM14.05 5.4c.65-.79 1.09-1.88.97-2.97-.94.04-2.08.63-2.75 1.41-.6.7-1.13 1.81-.99 2.88 1.05.08 2.12-.53 2.77-1.32z" />
    </svg>
  );
}

export function AppStoreBadge({ className }: { className?: string }) {
  return (
    <a
      href={APP_STORE_URL}
      className={cn(
        'group inline-flex items-center gap-3 rounded-2xl bg-foreground px-5 py-3 text-background',
        'transition-transform duration-200 hover:-translate-y-0.5 active:translate-y-0',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        className,
      )}
      aria-label="Download Bramble on the App Store"
    >
      <AppleGlyph className="size-7 shrink-0" />
      <span className="flex flex-col text-left leading-tight">
        <span className="font-mono text-[0.6rem] uppercase tracking-[0.18em] opacity-70">
          Download on the
        </span>
        <span className="font-display text-[1.15rem] font-semibold tracking-tight">App Store</span>
      </span>
    </a>
  );
}
